import React from "react";

import Information from "./Information";

const BlackoutAlert = (props) => {
  return (
    <Information title="Cash Out Requests are currently in a blackout period.">
      We are in a routine blackout period while we finalize the previous quarter's numbers. Transactions cannot be
      requested or processed during the blackout period. Please check back before the end of the month.
    </Information>
  );
};

export default BlackoutAlert;
